import axios from 'axios'
import EventBus from '@/event_bus'
import qs from 'qs';

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  baseURL: process.env.VUE_APP_API_BASE
  // timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)
_axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.paramsSerializer = (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
    return config
  },
  function(error) {
    // Do something with request error
    EventBus.$emit('REQUEST_ERROR', error)
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response
  },
  function(error) {
    // Do something with response error
    console.dir(error)
    if (!error.response.status || error.response.status >= 500)
      EventBus.$emit('RESPONSE_ERROR', error)
    return Promise.reject(error)
  }
)

export default _axios
